module.exports = "/assets/9f1674595ee7717e4517df8a478f15ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/M8.png
// module id = 2729
// module chunks = 0